import { tns } from 'tiny-slider/src/tiny-slider';

const showLeftButton = (carouselName) => {
  const slideBar = document.querySelector(`[data-${carouselName}-carousel]`);
  const leftButton = document.querySelector(`.${carouselName}-btn__left`);
  const isInstafeed = carouselName === 'instagram';

  if (isInstafeed) leftButton.style.display = 'block';

  slideBar.addEventListener('transitionend', () => {
    if (isInstafeed) return;
    leftButton.style.display =
      slideBar.getBoundingClientRect().left === 0 ? 'none' : 'block';
  });
};

export const showCarousel = (carouselName) => {
  const carouselElement = document.querySelector(
    `[data-${carouselName}-carousel]`
  );
  const isInstafeed = carouselName === 'instagram';

  if (carouselElement) {
    tns({
      container: carouselElement,
      mode: 'carousel',
      speed: 500,
      mouseDrag: true,
      autoWidth: true,
      gutter: 16,
      loop: isInstafeed,
      center: isInstafeed,
      rewind: !isInstafeed,
      controlsText: [
        `<i class="btn-arrow-box-left ${carouselName}-btn__left"></i><span class="visually-hidden">Prev</span>`,
        `<i class="btn-arrow-box-right ${carouselName}-btn__right"></i><span class="visually-hidden">Next</span>`,
      ],
      onInit: () => {
        showLeftButton(carouselName);
      },
    });
  }
};
